module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-tuberia-pipe.618f1d3c.jpg";